export default __webpack_public_path__ + "static/media/genesis.06a5ec89.svg";